import styled from '@emotion/styled';
import {
  ButtonNormalPrimaryMedium,
  ContentCompact,
  InfoBanner,
  Section,
  TitleAndDescription,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { HeaderHome } from 'components/headers/HeaderNotification';
import { VeterinaryIllustration } from 'components/illustration/VeterinaryIllustration';

export const TelevetAccessIntent = () => {
  return (
    <ContentCompact>
      <HeaderHome />
      <Section>
        <TitleAndDescription
          title="Teleconsulta veterinária"
          description="Médicos veterinários qualificados para orientações imediatas 24h por dia, 7 dias por semana."
        />

        <AlignCenterSelf>
          <VeterinaryIllustration />
        </AlignCenterSelf>

        <InfoBanner>
          O atendimento da teleconsulta pet é feito por meio de um chat online.
          Você tem direito a teleconsultas veterinárias, sem necessidade de
          agendamento prévio.
        </InfoBanner>

        <LinkWrapper href="/iframe">
          <ButtonNormalPrimaryMedium>
            Entrar na teleconsulta pet
          </ButtonNormalPrimaryMedium>
        </LinkWrapper>
      </Section>
    </ContentCompact>
  );
};

const AlignCenterSelf = styled.div`
  align-self: center;
`;
